const NAMESPACE = 'CHATBOT_SIDEBAR_STATE';

export const SET_IS_MINIMIZED = `${NAMESPACE}__SET_IS_MINIMIZED`;
export const TOGGLE_MENU_GROUP_EXPANDED = `${NAMESPACE}__TOGGLE_MENU_GROUP_EXPANDED`;
export const RESET_MENU = `${NAMESPACE}__RESET_MENU`;

export type SetIsMinimizedAction = ReturnType<typeof setIsMinimized>;
export type ToggleMenuGroupExpandedAction = ReturnType<
  typeof toggleMenuGroupExpanded
>;
export type ResetMenuAction = ReturnType<typeof resetMenu>;

const setIsMinimized = (isMinimized: boolean) => ({
  type: SET_IS_MINIMIZED,
  isMinimized,
});

const toggleMenuGroupExpanded = (menuGroupId: string) => ({
  type: TOGGLE_MENU_GROUP_EXPANDED,
  menuGroupId,
});

const resetMenu = () => ({
  type: RESET_MENU,
});

const chatbotSidebarActions = {
  setIsMinimized,
  toggleMenuGroupExpanded,
  resetMenu,
};

// TODO MM4580 - consider removal
export default chatbotSidebarActions;
